import { render, staticRenderFns } from "./ButtonChangePassword.vue?vue&type=template&id=75a3b570&"
import script from "./ButtonChangePassword.vue?vue&type=script&lang=js&"
export * from "./ButtonChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports